import React, { useEffect, useMemo, useState } from 'react';
import { Button, ButtonContainer, Fieldset, Layout } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { ComboboxOption } from 'types/bronson-react';
import { useDispatch } from 'react-redux';
import { RequestHistoryFilters, requestHistoryFiltersActions } from './RequestHistoryFiltersSlice';
import { SelectField } from './SelectField';
import { useFormikContext } from 'formik';
import { ContractFilterSelection } from './ContractFilterSelection';
import { Contract, ContractDetails } from 'cpfr-common';

const DateFilter: ComboboxOption[] = [
    { key: 'all', value: 'Tous' },
    { key: 'last3Months', value: '3 derniers mois' },
    { key: 'last6Months', value: '6 derniers mois' },
    { key: 'last12Months', value: '12 derniers mois' },
];

const StatusFilter: ComboboxOption[] = [
    { key: 'all', value: 'Tous' },
    { key: 'A traiter', value: 'A traiter' },
    { key: 'En cours de traitement', value: 'En cours de traitement' },
    { key: 'Traitée', value: 'Traitée' },
    { key: 'Annulée', value: 'Annulée' },
];

export const FiltersSection: React.FC<{ contracts: (Contract & ContractDetails)[] }> = ({ contracts }) => {
    const { values, setFieldValue } = useFormikContext<RequestHistoryFilters>();
    const [clearing, setClearing] = useState(false);
    const { t } = useTranslation('request-history');
    const dispatch = useDispatch();

    const clearAllFilters = () => {
        setClearing(true);
        setFieldValue('contractFilter', 'all');
        setFieldValue('dateFilter', 'all');
        setFieldValue('statusFilter', 'all');
        dispatch(requestHistoryFiltersActions.clearFilters());
    };

    useEffect(() => {
        dispatch(requestHistoryFiltersActions.setContractFilter(values.contractFilter));
        dispatch(requestHistoryFiltersActions.setDateFilter(values.dateFilter));
        dispatch(requestHistoryFiltersActions.setStatusFilter(values.statusFilter));
        setClearing(false);
    }, [values]); // eslint-disable-line react-hooks/exhaustive-deps

    const isClearFilterDisabled = useMemo(
        () => values.contractFilter === 'all' && values.dateFilter === 'all' && values.statusFilter === 'all',
        [values],
    );

    return (
        <>
            <Fieldset>
                <Fieldset.Row>
                    <Layout>
                        <Layout.Item default="1/4" s="1/1">
                            <ContractFilterSelection clearing={clearing} contracts={contracts} />
                        </Layout.Item>
                        <Layout.Item default="1/4" s="1/1">
                            <SelectField
                                testId={'date-filter'}
                                name={'dateFilter'}
                                options={DateFilter}
                                label={t('filters.date-filter-header')}
                                visible={!clearing}
                            />
                        </Layout.Item>
                        <Layout.Item default="1/4" s="1/1">
                            <SelectField
                                testId={'status-filter'}
                                name={'statusFilter'}
                                options={StatusFilter}
                                label={t('filters.status-filter-header')}
                                visible={!clearing}
                            />
                        </Layout.Item>
                        <Layout.Item default="1/4" s="1/1">
                            <ButtonContainer className={'u-mt'} center>
                                <Button
                                    secondary
                                    disabled={isClearFilterDisabled}
                                    onClick={clearAllFilters}
                                    testId={'clear-filters-button'}
                                >
                                    {t('filters.clear-all')}
                                </Button>
                            </ButtonContainer>
                        </Layout.Item>
                    </Layout>
                </Fieldset.Row>
            </Fieldset>
        </>
    );
};
